import 'bootstrap';
import $ from 'jquery'

import chunk from 'lodash/chunk'
import uniqueId from 'lodash/uniqueId'
import throttle from 'lodash/throttle'
import truncate from 'lodash/truncate'
import ClipboardJS from 'clipboard'


window.console.log('⚡️ Front End Init')

/**
 * Setup Liveplayer/Header Scrolling Transitions
 */
const transitionTime = 500 // maps to transition time in css
let HEADER_HEIGHT = 0
let HEADER_CONTAINER_HEIGHT = 0

/**
 * Toggle Search
 * Show and hide search form in header
 */
 function toggleSearch (e) {
   if($('#header #search-nav').hasClass('always-visible')) {
     e.preventDefault()
     return false
   }
  $('#header #search-nav').toggleClass('d-none')
  if(!$('#header #search-nav').hasClass('d-none')) {
    $('#search-nav #s').focus()
  }
}

$('#header').on('click', '#search-icon', toggleSearch)


$(".collapse").on('shown.bs.collapse', function(){
  $('#mobile-search-form').removeClass('d-none')
});
$(".collapse").on('hide.bs.collapse', function(){
  $('#mobile-search-form').addClass('d-none')
});



/**
 * Calculate Header Height on Scroll/Resize
 * Set main margin to said height
 */
var calculateHeaderHeight = function (firstRun = false) {

  // let ad = document.getElementById('hbi_ad_above_content')
  // let liveplayer = document.getElementById('liveplayer')
  let header = document.querySelector('.header-wrap')
  let headerContainer = document.getElementById('header-container')
  let headerContainerHeight = headerContainer.getBoundingClientRect().height
  let height = header.getBoundingClientRect().height
  let toolbar = document.getElementById('wpadminbar')

  if(toolbar) {
    height = height - toolbar.getBoundingClientRect().height || 32;
  }

  HEADER_HEIGHT = height
  HEADER_CONTAINER_HEIGHT = headerContainerHeight

  // window.console.log('calculateHeaderHeight', HEADER_HEIGHT, HEADER_CONTAINER_HEIGHT)

  if(firstRun) {
    toggleHeaders(firstRun)
  }
}



/**
 * Scrolling Behavior
 * Hide main header when scrolling down page
 * Resize large home page player when scrolling down page
 * @TODO: Make calls use consistent jQuery APIs
 */
 function toggleHeaders () {

  // window.console.log('toggleHeaders','window.scrollY',window.scrollY)

  // increase resize trigger during scroll if we page is showing large player
  const threshold = $('body').hasClass('large-player') ? (HEADER_CONTAINER_HEIGHT*2) : 19

  if(window.scrollY > threshold) {
    $('body').addClass('up')
    $('.home #liveplayer').addClass('compact')
  } else {
    $('body').removeClass('up')
    $('.home.large-player #liveplayer').removeClass('compact')
  }

  document.getElementById('main').style.paddingTop = `${HEADER_HEIGHT}px`;

  if($('body').hasClass('up')) {
    document.getElementById('header-container').style.marginTop = `-${HEADER_CONTAINER_HEIGHT}px`;
  } else {
    document.getElementById('header-container').style.marginTop = `0px`;
  }
}


$(window).on('scroll', throttle(toggleHeaders, 100) );

$(document).resize(() => {
  calculateHeaderHeight()
})

window.addEventListener('DOMContentLoaded', calculateHeaderHeight(true))

// debug
// window.addEventListener('DOMContentLoaded', hllLiveBarWidget.debug(0))

/**
 * Detect Breakpoint
 * @see footer.php with associated HTML markup
 * @link https://stackoverflow.com/a/22885503/1167354
 */
 function isBreakpoint( alias ) {
    return $('.device-' + alias).is(':visible');
 }

 function isMobile() {
   if(isBreakpoint('xs') || isBreakpoint('sm')) {
    return true
   }
   return false
 }

$(window).resize(function() {
  if(isMobile()) {
    $('#liveplayer').addClass('compact')
    toggleHeaders()
  }
})

$(function() {
  if(isMobile()) {
    $('#liveplayer').addClass('compact')
  }
})

/**
 * Generate window options for sharing
 */
const getWindowOptions = function() {
  const width = 550
  const height = 350
  const left = (window.innerWidth / 2) - (width / 2)
  const top = (window.innerHeight / 2) - (height / 2)

  return [
    'resizable,scrollbars,status',
    'height=' + height,
    'width=' + width,
    'left=' + left,
    'top=' + top,
  ].join()
}

/**
 * Facebook Share Dialog
 */
 function fbShareDialog (e) {
  e.preventDefault()
  const text = document.title
  const shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href
  const win = window.open(shareUrl, 'ShareOnFacebook', getWindowOptions())
  win.opener = null
}

$('.article-share-top').on('click', '.fa-facebook-f', fbShareDialog)


/**
 * Twitter Share Dialog
 * @link https://guides.codechewing.com/add-custom-twitter-share-button-to-websites
 */
function twitterShareDialog (e) {
  e.preventDefault()
  const text = document.title
  const shareUrl = 'https://twitter.com/intent/tweet?url=' + window.location.href + '&text=' + text
  const win = window.open(shareUrl, 'ShareOnTwitter', getWindowOptions())
  win.opener = null
}

$('.article-share-top').on('click', '.fa-twitter', twitterShareDialog)


/**
 * Don't reload page when clicking permalink icon, it's just meant for right-clicking and copying
 * TODO: Make it copy to clipboard and display a nice-looking message
 */
$('.article-share-top').on('click', '.fa-link', function(e) {
  e.preventDefault()
})


/**
 * Allow linking to show page tabs
 * Slightly overrides Bootstrap tabs functionality to let you link to a specific tab
 * https://stackoverflow.com/questions/7862233/twitter-bootstrap-tabs-go-to-specific-tab-on-page-reload-or-hyperlink/9393768#9393768
 */

const url = document.location.toString();
if (url.match('#')) {
  let tab = $('.nav.panel-items a[href="#' + url.split('#')[1] + '"]')
  if(tab.length > 0) {
    tab.tab('show');
    setTimeout(function(){
      window.scrollTo(0, 0);
      //Rebuild carousels
      jQuery('.jcarousel').trigger('jcarousel:reload');
    }, 500)
  }
}

$('.nav.panel-items').on('click','a', function (e) {
  let href = $(this).attr('href')
  if(href.startsWith("#")) {
    e.preventDefault()
    $(this).tab('show')
    //Rebuild carousels
      setTimeout(function(){ jQuery('.jcarousel').trigger('jcarousel:reload')}, 500);
    window.location.hash = e.target.hash
  }
})

/**
 * Make the Bootstrap Navbar Dropdown Work on Hover
 * @link https://webdesign.tutsplus.com/tutorials/how-to-make-the-bootstrap-navbar-dropdown-work-on-hover--cms-33840
 */

const $dropdown = $(".dropdown");
const $dropdownToggle = $(".dropdown-toggle");
const $dropdownMenu = $(".dropdown-menu");
const showClass = "show";

$(window).on("load resize", function() {
  if (this.matchMedia("(min-width: 768px)").matches) {
    $dropdown.hover(
      function() {
        const $this = $(this);
        $this.addClass(showClass);
        $this.find($dropdownToggle).attr("aria-expanded", "true");
        $this.find($dropdownMenu).addClass(showClass);
      },
      function() {
        const $this = $(this);
        $this.removeClass(showClass);
        $this.find($dropdownToggle).attr("aria-expanded", "false");
        $this.find($dropdownMenu).removeClass(showClass);
      }
    );
  } else {
    $dropdown.off("mouseenter mouseleave");
  }
});

/**
 * Allow dropdown menu items to appear even when parent column is overflow:hidden
 * Applies only to desktop breakpoints
 */
$(document).ready(function() {

  // fix position of hovered menu items to break out of overflow'ed container
  $('.menu-item-has-children').on('mouseover', function () {
    if(isBreakpoint('lg') || isBreakpoint('xl')) {

      let height = 55; // setting a manual height because automatic height is unreliable
      let top = $(this).children('a').first().offset().top + height;
      const left = $(this).offset().left;

      // use position() instead of offset() when parent header is fixed to top and scrolling
      if($('body').hasClass('up')) {

        // fixed wordpress admin bar throws things off
        if($('body').hasClass('admin-bar')) {
          height += 32;
        }

        top = $(this).children('a').first().position().top + height;

      }

      let $dropdown = $(this).children('.dropdown-menu').first()
      $dropdown.css({'position':'fixed', 'left': left, 'top': top})
    }
  })

  // then reset when done hovering, just in case user changes to small breakpoint
  $('.menu-item-has-children').on('mouseleave', function () {
    if(isBreakpoint('lg') || isBreakpoint('xl')) {
      let $dropdown = $(this).children('.dropdown-menu').first()
      $dropdown.css({'position':'initial', 'left': 0, 'top': 0})
    }
  })
})


/**
 * Force first slides to be active on sliders with base theme
 * - There is some kind of bug causing it to not set
 */
$( document ).ready(function() {
  var slidersTabContainers = $('.soliloquy-thumbnails-container.soliloquy-theme-classic');
  slidersTabContainers.each(function(index) {

    // Find sibling slides
    var sibling_slider = $(this).prev('.soliloquy-outer-container');

    // Default active slide
    var active_slide = sibling_slider.find('li.soliloquy-active-slide');
    if(active_slide.length > 0) {
      var dataIndex = active_slide.index();
      var shouldBeActive = $(this).find("li[data-index='"+dataIndex+"']");
      shouldBeActive.addClass('soliloquy-active-slide');
    }

    // Make thumbnail arrows change slides
    $(this).find("a.soliloquy-prev")[0].outerHTML = $(this).find("a.soliloquy-prev")[0].outerHTML;
    $(this).find("a.soliloquy-prev").click(function(e) {
      var sliderPrev = sibling_slider.find("a.soliloquy-prev");
      if(sliderPrev.length > 0) {
        sliderPrev[0].click();
      }
      return false;
    });

    $(this).find("a.soliloquy-next")[0].outerHTML = $(this).find("a.soliloquy-next")[0].outerHTML;
    $(this).find("a.soliloquy-next").click(function(e) {
      var sliderNext = sibling_slider.find("a.soliloquy-next");
      if(sliderNext.length > 0) {
        sliderNext[0].click();
      }
      return false;
    });

  });
});

// Enable Tooltips
$(function () {
  if($('#share-link').length > 0) {
    $('[data-toggle="tooltip"]').tooltip();
  }
})

// Copy Share Link to Clipboard
$( document ).ready(function() {
  new ClipboardJS('#share-link');
});

// Open external article links in new tab
$( document ).ready(function() {
  $('article a[rel="nofollow"]')
  .not('[href*="' + window.location.host + '"]')
  .attr('target', '_blank')
})

// Truncate divs that are too long and append more button
// https://jsfiddle.net/7Vv8u/5816/
$( document ).ready(function() {

  // https://stackoverflow.com/questions/783899/how-can-i-count-text-lines-inside-an-dom-element-can-i

  const $collapsables = $('.limit-length')

  $collapsables.each(function(item, element) {

    // collapse only if longer than about 2 lines
    let height = $(element).height()
    if(height < 73) {
      return
    }

    $(this).addClass('collapsed')
    $(this).parent().removeClass('align-self-center')
    $(this).after('<span class="more">Show More...</span><span class="less">Show Less</span><div class="clearfix">&nbsp;</div>')
    $('span.less').hide()
  })

  $(document).on('click', 'span.more' , function() {
    $('.limit-length').removeClass('collapsed')
    $(this).hide().siblings('.less').show();
  });

  $(document).on('click', 'span.less' , function() {
    $(this).siblings('.limit-length').addClass('collapsed')
    $(this).hide().siblings('.more').show();
  });

});


// Advertiser Directory Content Limits
// Truncate text with a more/less button
// https://slickmedia.co.uk/blog/glenns-blog/limit-number-of-characters-in-div-jquery-css/
//
$(function(){
  $(".endorsement-text").each(function () {
    const maxlength = 180;
    $(this).data('original', $(this).text());
    let len = $(this).text().length
    let str = $(this).text().substr(0,maxlength)
    let lastIndexOf = str.lastIndexOf(" ")
    if(len > maxlength) {

      let truncated = str.substr(0, lastIndexOf) + '...'
      $(this).data('truncated', truncated)
      $(this).text(truncated)

      // this element starts hidden and then displayed with javascript to avoid resize/flash
      $(this).addClass('d-inline')

      $(this).after('<span class="endorsement-text-more ml-1" title="Show more..."><small>[Show More]</small></span><div class="endorsement-text-less my-1" title="Show Less">⌃</div>')
    }

    $(this).removeClass('d-none')

  })

  $('.endorsement-text-less').hide();

  $(document).on('click', '.endorsement-text-more' , function() {
    $(this).hide().siblings('.endorsement-text-less').show()
    let $el = $(this).parent().children('.endorsement-text')
    let text = $el.data('original')
    $el.text(text)
  });

  $(document).on('click', '.endorsement-text-less' , function() {
    $(this).hide().siblings('.endorsement-text-more').show()
    let $el = $(this).parent().children('.endorsement-text')
    let text = $el.data('truncated')
    $el.text(text)
  });

})



// Prepend icon to Instagram Widgets
$( document ).ready(function() {
  $('.hbi-instagram-widget .widgettitle, .widget_instagram-feed-widget .widgettitle').prepend('<i class="fab fa-instagram fa-lg mr-2"></i>')
})

// Prepend icon to Youtube Widgets
$( document ).ready(function() {
  $('.widget_hubbard_youtube_playlists_widget .widgettitle, .widget_hubbard_newest_youtube_video .widgettitle').prepend('<i class="fab fa-youtube fa-lg mr-2"></i>')
})

/**
 * Youtube URL Parser
 * Gets Youtube ID from a URL
 * @link https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
 * @param  {string} url
 * @return string or false
 */
function youtube_parser(url){
  if(url === undefined || !url) {
    return false;
  }
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return (match&&match[7].length==11)? match[7] : false;
}




/**
 * Alow only one Youtube to play at a time
 * Also adds logic to Youtube videos in Advertiser Directory
 * Uses the Youtube iframe API
 * @link https://stackoverflow.com/questions/7443578/youtube-iframe-api-how-do-i-control-an-iframe-player-thats-already-in-the-html
 * @link https://stackoverflow.com/questions/12994459/how-to-stop-embedded-youtube-videos-from-playing-simultaneously
 * @link https://developers.google.com/youtube/iframe_api_reference
 */

 // Load the Youtube IFrame Player API code asynchronously
 var tag = document.createElement('script');
 tag.src = 'https://www.youtube.com/iframe_api';
 var firstScriptTag = document.getElementsByTagName('script')[0];
 firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

 // Track state of all players on the page
 var ytPlayers = new Array();
 var ytPlayerStates = new Array();

window.onYouTubePlayerAPIReady = function()
{

    console.log('⚡️ YouTubePlayerAPIReady')

    // scan all iframes on the page
    jQuery('iframe').each(function(index)
    {
        let src = jQuery(this).attr('src');

        // check if this iframe is a Youtube Video
        let iframeID = youtube_parser(src);

        if(!iframeID) {
          return
        }

        // Append options to Youtube embed querystring:
        // enablejsapi: required to enable Javascript APIs
        // origin: protects against injection attacks

        // check if URL already has querystring
        if (src.indexOf('?') > -1) {
          src = `${src}&`
        } else {
          src = `${src}?`
        }

        let newEmbedURL = `${src}enablejsapi=1&origin=${window.location.origin}`;
        jQuery(this).attr('src',newEmbedURL);

        // Apply Youtube ID to this iFrame
        jQuery(this).attr('id',iframeID);
        ytPlayerStates[iframeID] = -1;

        // Append events to each Youtube Video
        (function (iframeID) {
            ytPlayers.push(new YT.Player(iframeID, {
                events: {
                    'onStateChange' : function (event) {
                        let state = event.data

                        // track changes to player states in array
                        // -1 = unstarted, 0 = ended, 1 = playing, 2 = paused, 3 = loading?, 5 = cued
                        ytPlayerStates[iframeID] = state

                        if (state == 1)
                        {

                          // Pause featured carousel on Advertiser page when embedded videos are playing
                          // https://stackoverflow.com/questions/17038699/pausing-bootstrap-carousel-when-a-video-playing
                          console.log('pausing carousel');
                          $('#carouselFeatured').carousel({'pause': false}) // Stop the carousel from cycling through items
                          $('#carouselFeatured').carousel('pause')

                          // iterate over all players on the page, pausing all except the one currently playing
                          // console.log(iframeID, 'playing') // debug
                          var i = 0;
                          for (var key in ytPlayerStates) {
                            if(key !== iframeID) {
                              // console.log(i,'key',key,'should be stopped') // debug
                              ytPlayers[i].pauseVideo()
                            }
                            i++;
                          }
                        }

                        if ( state == 0 || state == 2) {
                          // After video is done, unpause Advertiser carousel
                          console.log('unpausing carousel');
                          $('#carouselFeatured').carousel()
                        }

                    }
                }
            }));

        })(iframeID);
    });

    // console.log('ytPlayers',ytPlayers) // debug, log available players console

    $('#carouselFeatured').on('slide.bs.carousel', function () {
      window.console.log('slide.bs.carousel happened', 'pausing...')
      ytPlayers.forEach((player) => {
        if (typeof player.pauseVideo === 'function') {
            player.pauseVideo()
        }
      })
    })

}


// HBI Slider Widget Plugin Logic
$.fn.scrollDivToElement = function(childSel) {
  if (! this.length) return this;

  return this.each(function() {
    let parentEl = $(this);
    let childEl = parentEl.find(childSel);

    if (childEl.length > 0) {
      let position = parentEl.scrollLeft() - parentEl.offset().left + childEl.offset().left - (parentEl.outerWidth() / 2) + (childEl.outerWidth() / 2);
      parentEl.animate({
        scrollLeft: position
      }, 200, function() {
        // window.console.log('🍕 completed scrolling left', position);
      });
    }
  });
};

// slide title indicators in hbi-slider
$( document ).ready(function() {

  let $carousels = $('.hbi-slider-widget .wide .carousel');

  $carousels.on('slide.bs.carousel', function (e) {
    let $carousel = $(e.currentTarget);
    let slide_number = e.to;
    // window.console.log('slide:', slide_number);
    let $indicators = $carousel.next('.carousel-indicators:first');
    let active_selector = `[data-slide-to="${slide_number}"]`;
    $indicators.find('[data-slide-to]').removeClass('active');
    $(active_selector).addClass('active');
    $indicators.scrollDivToElement(active_selector);
  });

});



// Reposition Soliloquy Carousel controls in DOM so we can better style them
// @see /wp-content/themes/station-sites/assets/src/scss/_widgets.scss
$( document ).ready(function() {
  $('.soliloquy-carousel .soliloquy-has-controls-direction').each(function() {
    $(this).parent().parent().prepend($(this));
  });
})

window.showStreamFailedModal =  function() {
  jQuery('#invalidTokenModal').show();
}

window.closeStreamFailedModal =  function() {
  jQuery('#invalidTokenModal').hide();
}
